export default __webpack_public_path__ + "static/feature-discovery-flag-ea1f4725ab0afef747cd75c9e568f7e4.png";